import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ThemeWidgets.css';
import Link from '../../components/Link';
import { getWidgetsInTheme } from '../../data/widgets';
import { isHubReleased } from '../../data/widgets/release';

/**
 * «Что стоит в этой теме» — ссылки на лендинги виджетов.
 *
 * Тем на сайте тысячи, и до сих пор ни одна не вела внутрь каталога.
 * Блок собирается из appJSON самой темы, то есть ничего не выдумывает:
 * перечислены ровно те виджеты, которые человек получит, установив тему.
 *
 * Ещё не открытые лендинги отфильтрованы в getWidgetsInTheme — ссылка на
 * них вела бы на 404.
 */
function ThemeWidgets({ appJSON, title }) {
	if (!isHubReleased()) {
		return null;
	}

	// Больше десятка ссылок подряд читаются как список ради списка
	const widgets = getWidgetsInTheme(appJSON).slice(0, 10);

	if (widgets.length === 0) {
		return null;
	}

	return (
		<div className={s.root}>
			<h2>What this theme uses</h2>

			<p className={s.intro}>
				Install &ldquo;{title}&rdquo; and you get these widgets already
				placed. Each one can be moved, restyled or removed afterwards.
				Open a widget to see what it does.
			</p>

			<ul className={s.list}>
				{widgets.map(widget => (
					<li className={s.item} key={widget.slug}>
						<Link to={`/widgets/${widget.slug}`}>
							{widget.name}
						</Link>
					</li>
				))}
			</ul>

			<p className={s.all}>
				<Link to="/widgets">See every widget you can add</Link>
			</p>
		</div>
	);
}

ThemeWidgets.propTypes = {
	// eslint-disable-next-line react/forbid-prop-types
	appJSON: PropTypes.object.isRequired,
	title: PropTypes.string,
};

ThemeWidgets.defaultProps = {
	title: 'this theme',
};

export default withStyles(s)(ThemeWidgets);
